"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mutateValues_1 = require("./mutateValues");
exports.jsonSerialize = mutateValues_1.mutateValues(function (value) { return JSON.stringify(value); }, function (value) { return JSON.parse(value); });
//# sourceMappingURL=jsonSerialize.js.map